/**
 * Custom hook for copy functionality in PDFViewerPanel
 *
 * Extracted from PDFViewerPanel.tsx
 */

import { useCallback } from 'react';

interface UsePDFViewerPanelCopyProps {
  isSavedMessage: boolean;
  isStudioResult: boolean;
  isSnippet: boolean;
  savedMessageMarkdown: string;
  studioMarkdown: string;
  snippetMarkdown: string;
  detailText?: string;
}

/**
 * Provides copy handler for different content types
 */
export function usePDFViewerPanelCopy({
  isSavedMessage,
  isStudioResult,
  isSnippet,
  savedMessageMarkdown,
  studioMarkdown,
  snippetMarkdown,
  detailText,
}: UsePDFViewerPanelCopyProps) {
  const handleCopy = useCallback(() => {
    if (isSavedMessage && savedMessageMarkdown) {
      navigator.clipboard.writeText(savedMessageMarkdown);
      return;
    }
    if (isStudioResult && studioMarkdown) {
      navigator.clipboard.writeText(studioMarkdown);
      return;
    }
    if (isSnippet && snippetMarkdown) {
      navigator.clipboard.writeText(snippetMarkdown);
      return;
    }
    if (detailText) {
      navigator.clipboard.writeText(detailText);
    }
  }, [isSavedMessage, isStudioResult, isSnippet, savedMessageMarkdown, studioMarkdown, snippetMarkdown, detailText]);

  return { handleCopy };
}
